import type {Schema} from 'schemaDefinition/types';
import type {MergeSuggestion} from 'services/mergeSuggestions/types';

export const useMergeSuggestionSchema = (): Schema<MergeSuggestion> => ({
  name: 'mergeSuggestionSchema',
  parts: [
    {
      name: 'created',
      type: 'date',
    },
    {
      name: 'type',
      type: 'text',
    },
    {
      name: 'targetName',
      type: 'text',
    },
    {
      name: 'sourceName',
      type: 'text',
    },
    {
      name: 'targetId',
      type: 'text',
    },
    {
      name: 'sourceId',
      type: 'text',
    },
    {
      name: 'description',
      type: 'text',
    },
  ],
});
